import React from "react";
import { Row, Col } from "react-bootstrap";

import ProductCard from "./ProductCard";

const ProductList = ({
    products = [],
    onProductSelect
}) => {

    if (!products.length) {
        return (
            <div className="product-list-empty">
                <div className="product-list-empty-text">
                    محصولی یافت نشد
                </div>
            </div>
        );
    }

    return (
        <div className="product-list">
            <Row className="product-list-row">

                {products.map((product, index) => (
                    <Col
                        key={
                            product.id ??
                            product.ID ??
                            product.productId ??
                            index
                        }
                        xs={12}
                        sm={6}
                        className="product-card-column"
                    >
                        <ProductCard
                            product={product}
                            onClick={onProductSelect}
                        />
                    </Col>
                ))}

            </Row>
        </div>
    );
};

export default ProductList;
